module.exports = __webpack_public_path__ + "img/trash.e6887622.svg";